import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { LangProvider } from './context/LangContext';
import { CartProvider }  from './context/CartContext';
import { AudioProvider } from './context/AudioContext';
import { useFirstVisit } from './hooks/useFirstVisit';
import { useRoute } from './hooks/useRoute';
import WaterBackground   from './components/WaterBackground';
import CustomCursor      from './components/ui/CustomCursor';
import ScrollToTop       from './components/ui/ScrollToTop';
import SiteNav           from './components/layout/SiteNav';
import Footer            from './components/layout/Footer';
import Player            from './components/layout/Player';
import CinematicIntro    from './components/intro/CinematicIntro';
import Hero              from './components/sections/Hero';
import Trailer           from './components/sections/Trailer';
import Gallery           from './components/sections/Gallery';
import Record            from './components/sections/Record';
import Lives             from './components/sections/Lives';
import Shop              from './components/sections/Shop';
import Contact           from './components/sections/Contact';
import Privacy           from './components/sections/Privacy';

export default function App() {
  const [isFirstVisit, markSeen] = useFirstVisit();
  const { route } = useRoute();
  const isPrivacy = route === 'privacy';
  // Skip intro on privacy route entirely.
  const [introDone, setIntroDone] = useState(isPrivacy ? true : !isFirstVisit);

  const handleIntroComplete = () => {
    markSeen();
    setIntroDone(true);
  };

  return (
    <LangProvider>
      <CartProvider>
        <AudioProvider>
          <AnimatePresence>
            {!isPrivacy && !introDone && (
              <CinematicIntro key="intro" onComplete={handleIntroComplete} />
            )}
          </AnimatePresence>
          <WaterBackground />
          <CustomCursor />
          <a href="#hero" className="skip-to-content">Skip to content</a>
          <SiteNav />

          {isPrivacy ? (
            <Privacy />
          ) : (
            <main style={{ position: 'relative', zIndex: 1 }}>
              <section id="hero">    <Hero introDone={introDone} /> </section>
              <Trailer />
              <section id="gallery"> <Gallery /> </section>
              <section id="record">  <Record />  </section>
              <section id="lives">   <Lives />   </section>
              <section id="shop">    <Shop />    </section>
              <section id="contact"> <Contact /> </section>
              <Footer />
            </main>
          )}

          {isPrivacy && <Footer />}
          {!isPrivacy && <Player />}
          <ScrollToTop />
        </AudioProvider>
      </CartProvider>
    </LangProvider>
  );
}
